import axios from 'axios';

export const apiForImages = process.env.REACT_APP_BACKEND_API_URL;
export const apiUrl = process.env.REACT_APP_BACKEND_API_URL;

const api = axios.create({
  baseURL: apiUrl,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});


api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const { data } = await axios.post(`${apiUrl}/token/refresh`, {}, { withCredentials: true });
        const { accessToken } = data;
        localStorage.setItem('token', accessToken);
        api.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        originalRequest.headers['Authorization'] = `Bearer ${accessToken}`;
        return api(originalRequest);
      } catch (refreshError) {
        console.error("Unable to refresh token, logging out.", refreshError);
        localStorage.removeItem('user');
        localStorage.removeItem('token');

        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);


export const requestData = async (endpoint) => {
  const { data } = await api.get(endpoint);
  return data;
};

export const requestLogin = async (endpoint, body) => {
  const { data } = await api.post(endpoint, body);
  return data;
};

export const uploadImage = async (endpoint, body) => {
  const { data } = await api.post(endpoint, body);
  return data;
};

export const criarCarteiras = async (endpoint, body) => {
  const { data } = await api.post(endpoint, body);
  return data;
};

export default api;
